import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 2,
  class: "flex-column opacity-75"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bold mt-5" }, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export interface propsComponent {
  isPreview: boolean;
}
import {
  useAttrs,
  computed,
  withDefaults,
  watch,
  ref,
} from "vue";
import { useRoute } from "vue-router";
import { FileAPI } from "@/services/api/File.service";
import { v4 as uuidv4 } from "uuid";

import FileUpload from "primevue/fileupload";
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "VZImage",
  inheritAttrs: false,
  components: {
    FileUpload,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  emits: ["customEvent"],
  setup(__props: any, { emit }) {

const props = __props as { isPreview: boolean }



const route = useRoute();
const attrs = useAttrs();
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };
  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});
const imageSrc = ref("");
const imageUploading = ref(false);
const imageLoading = ref(false);
const preview = computed(() => {
  return props.isPreview;
});
const sectionId = computed(() => {
  return route.params.id as string;
});
const style = computed(() => {
  return "width: 120px; height: 120px;";
});

async function customBase64Uploader(fileInput) {
  const file = fileInput.files[0];
  const reader = new FileReader();
  let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

  reader.readAsDataURL(blob);
  reader.onloadend = async (e: any) => {
    const id = uuidv4();
    const data = {
      id,
      ownerWebId: sectionId.value,
      name: file.name || attrs.name,
      entities: [
        {
          webId: sectionId.value,
          id,
          name: "section",
        },
      ],
      content: sectionId.value,
    };
    imageUploading.value = true;
    FileAPI.getInstance()
      .uploadFile(file, data)
      .then((response) => {
        emit("customEvent", { ...response.data, fieldId: attrs.id });
      })
      .catch((error) => {
        //
      })
      .finally(() => {
        imageUploading.value = false;
      });
  };
}

watch(
  () => attrs.imageId,
  async (value) => {
    try {
      if (value) {
        imageLoading.value = true;
        const response = await FileAPI.getInstance().fetchImage(`${value}`);
        if (response) {
          const { headers, data } = response;
          const mimeType = headers["content-type"].toLowerCase();
          const imgWithRedirect = Buffer.from(data, "binary").toString();
          const base64Img = imgWithRedirect.replace("redirect:", "");
          imageSrc.value = `${base64Img}`;
        }
      }
    } catch (error) {
      //
    } finally {
      imageLoading.value = false;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_unref(dynamicAttrs), { class: "VZ_TABLE_BUTTON d-flex" }), [
    (!_unref(preview))
      ? (_openBlock(), _createBlock(_unref(FileUpload), {
          key: 0,
          name: "image",
          url: "./upload",
          customUpload: "",
          onUploader: customBase64Uploader,
          multiple: false,
          accept: "image/*",
          auto: true,
          chooseLabel: "Browse",
          disabled: imageUploading.value
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (!imageLoading.value && imageSrc.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: imageSrc.value,
          style: _normalizeStyle(_unref(style))
        }, null, 12, _hoisted_1))
      : _createCommentVNode("", true),
    (imageLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true)
  ], 16))
}
}

})